import React, { useState } from "react";
import ComplexStatisticsCard from "./ComplexStatisticsCard";
import BugReportIcon from '@mui/icons-material/BugReport';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PendingIcon from '@mui/icons-material/Pending';


import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getAllClientIssueRpt, getDevOpsCount, getFixedCount, getIssueCount, loadAllIssueCount,
  loadClientIssuesReport,
  loadFixedIssueCount, loadForwardedIssueCount
} from "../../store/dashboard";
import { Box, Grid, Typography } from "@mui/material";
import ClientIssues from "./ClientIssues";
import Controls from "../controls/Controls";

const roles = [
  {
    title: "TDA",
    id: 1,
  },
  {
    title: "IPCS",
    id: 2,
  },
];

export default function Dashboard() {

  const [allIssueCount, setAllIssueCount] = useState(0);
  const [fixedIssueCount, setFixedIssueCount] = useState(0);
  const [forwardedIssueCount, setForwardedIssueCount] = useState(0);
  const [allClients, setAllClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState("");
  const [selectedApplicationId, setSelectedApplicationId] = useState("");
  const [clientIssueRpt, setClientIssueRpt] = useState([]);
  const [issueshowhide, setIssueshowhide] = useState(false);

  const issueCountSelector = useSelector(getIssueCount);
  const fixedCountSelector = useSelector(getFixedCount);
  const devOpsCountSelector = useSelector(getDevOpsCount);
  const allClientIssueRptSelector = useSelector(getAllClientIssueRpt);

  const navigate = useNavigate();
  const dispatach = useDispatch();

  useEffect(() => {
    dispatach(loadAllIssueCount());
    dispatach(loadFixedIssueCount());
    dispatach(loadForwardedIssueCount());
    dispatach(loadClientIssuesReport());
  }, []);

  useEffect(() => { setAllIssueCount(issueCountSelector) }, [issueCountSelector]);
  useEffect(() => { setFixedIssueCount(fixedCountSelector) }, [fixedCountSelector]);
  useEffect(() => { setForwardedIssueCount(devOpsCountSelector) }, [devOpsCountSelector]);

  useEffect(() => {
    if (allClientIssueRptSelector.length > 0) {
      setClientIssueRpt(allClientIssueRptSelector);
      const clientList = [];
      allClientIssueRptSelector.map(item =>
        clientList.push({ id: item.clientId, title: item.clientName })
      )
      setAllClients(clientList);
    }
  }, [allClientIssueRptSelector]);

  useEffect(() => {
    if (selectedClientId) {
      const obj = clientIssueRpt.filter(x => x.clientId === selectedClientId);
      if (obj.length > 0) {
        setAllIssueCount(obj[0].totalIssues);
        setFixedIssueCount(obj[0].fixedIssues);
        setForwardedIssueCount(obj[0].devOpsForwardedIssues);
      }
    }
    else {
      setAllIssueCount(issueCountSelector);
      setFixedIssueCount(fixedCountSelector);
      setForwardedIssueCount(devOpsCountSelector);
    }
  }, [selectedClientId])

  const handleClick = () => {
    setIssueshowhide(true)
  }

  const handleChangeClient = ({ target }) => {
    setSelectedClientId(target.value);
  }

  const handleChangeApplication = ({ target }) => {
    setSelectedApplicationId(target.value);
  }

  const allApplications = [
    { id: 1, title: "A" }, { id: 2, title: "B" }, { id: 2, title: "B" }]


  return (
    <Box py={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <Controls.Select
            id="client"
            name="client"
            label="Select Customer"
            option={allClients}
            value={selectedClientId}
            onChange={handleChangeClient}
            sx={{ backgroundColor: "white" }}
          />
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
          <Controls.Select
            id="application"
            name="application"
            label="Select Application"
            option={allApplications}
            value={selectedApplicationId}
            onChange={handleChangeApplication}
            disabled={!selectedClientId}
            sx={{ backgroundColor: "white" }}
          />
        </Grid>
        {selectedClientId && selectedApplicationId && (
          <>
            <Grid item lg={12}>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Total Issues
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Box mb={1.5}>
                <ComplexStatisticsCard
                  color="dark"
                  icon={<BugReportIcon />}
                  title=""
                  count={allIssueCount}
                  desc="Received"
                  handleClick={handleClick}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Box mb={1.5}>
                <ComplexStatisticsCard
                  color="#ffd600"
                  icon={<PendingIcon />}
                  title=""
                  count={allIssueCount - fixedIssueCount}
                  desc="Review"
                  handleClick={handleClick}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Box mb={1.5}>
                <ComplexStatisticsCard
                  color="#0bb26a"
                  icon={<DoneAllIcon />}
                  title=""
                  count={fixedIssueCount}
                  desc="Fixed"
                  handleClick={handleClick}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Box mb={1.5}>
                <ComplexStatisticsCard
                  color="#1976d2"
                  icon={<CloudDoneIcon />}
                  title=""
                  count={forwardedIssueCount}
                  desc="Forwarded to DevOps"
                  handleClick={handleClick}
                />
              </Box>
            </Grid>
            {issueshowhide && (
              <>
                <Grid item lg={12}>
                  <ClientIssues clientIssueRpt={clientIssueRpt} />
                </Grid>
              </>
            )}

          </>
        )}
        {/* <Grid item lg={12}>
          <Typography variant="h5" sx={{ mb: 2 }}>Total Issues</Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Box mb={1.5}>
            <ComplexStatisticsCard
              color="dark"
              icon={<BugReportIcon />}
              title=""
              count={allIssueCount}
              desc="Received"
              handleClick={handleClick}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Box mb={1.5}>
            <ComplexStatisticsCard
              color="error"
              icon={<PendingIcon />}
              title=""
              count={allIssueCount - fixedIssueCount}
              desc="Pending"
              handleClick={handleClick}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Box mb={1.5}>
            <ComplexStatisticsCard
              color="success"
              icon={<DoneAllIcon />}
              title=""
              count={fixedIssueCount}
              desc="Fixed"
              handleClick={handleClick}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Box mb={1.5}>
            <ComplexStatisticsCard
              color="primary"
              icon={<CloudDoneIcon />}
              title=""
              count={forwardedIssueCount}
              desc="Forwarded to DevOps"
              handleClick={handleClick}
            />
          </Box>
        </Grid>
        <Grid item lg={12}>
          <ClientIssues clientIssueRpt={clientIssueRpt} />
        </Grid> */}
      </Grid>
    </Box>
  );
}
